import React from 'react';
export const HerbSprig = ({
  className = '',
  color = '#2D5F3F',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-119">
    <path d="M12 22v-7l-2-2" data-id="element-120" />
    <path d="M12 15l2-2" data-id="element-121" />
    <path d="M10 13a3 3 0 0 1-3-3c0-2 2-3 2-3s1 2 1 4" data-id="element-122" />
    <path d="M14 13a3 3 0 0 0 3-3c0-2-2-3-2-3s-1 2-1 4" data-id="element-123" />
    <path d="M12 11a3 3 0 0 1-3-3c0-2 2-3 2-3s1 2 1 4" data-id="element-124" />
    <path d="M12 11a3 3 0 0 0 3-3c0-2-2-3-2-3s-1 2-1 4" data-id="element-125" />
  </svg>;
export const MortarPestle = ({
  className = '',
  color = '#A88838',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-126">
    <path d="M7 10l-2 10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2l-2-10" data-id="element-127" />
    <path d="M4 10h16" data-id="element-128" />
    <path d="M15 4l-4 6" data-id="element-129" />
    <path d="M17 2l-2 2" data-id="element-130" />
  </svg>;
export const LeafCluster = ({
  className = '',
  color = '#6B9A7A',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-131">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-132" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-133" />
  </svg>;
export const TinctureBottle = ({
  className = '',
  color = '#C9A961',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 24" className={className} style={style} fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-134">
    <path d="M10 2v3" data-id="element-135" />
    <path d="M14 2v3" data-id="element-136" />
    <path d="M8 5h8v3a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5z" data-id="element-137" />
    <path d="M7 10h10v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V10z" data-id="element-138" />
    <path d="M12 12v6" data-id="element-139" />
    <path d="M10 15l2-2 2 2" data-id="element-140" />
  </svg>;
export const FeatherQuill = HerbSprig;
export const Flame = MortarPestle;
export const MoonPhase = LeafCluster;
export const LotusBud = TinctureBottle;
export const HealingBackgroundDecor = ({
  className = ''
}: {
  className?: string;
}) => <div className={`absolute inset-0 pointer-events-none overflow-hidden -z-10 ${className}`} aria-hidden="true" data-id="element-141">
    <HerbSprig className="absolute top-10 left-[5%] w-8 h-8 opacity-15 animate-float-soft" color="#2D5F3F" style={{
    ['--rot' as any]: '15deg',
    transform: 'rotate(15deg)'
  }} data-id="element-142" />
    <LeafCluster className="absolute top-40 right-[8%] w-10 h-10 opacity-15 animate-float-soft" color="#6B9A7A" style={{
    ['--rot' as any]: '-25deg',
    transform: 'rotate(-25deg)',
    animationDelay: '1s'
  }} data-id="element-143" />
    <TinctureBottle className="absolute bottom-20 left-[8%] w-12 h-12 opacity-15 animate-float-soft" color="#C9A961" style={{
    animationDelay: '2s'
  }} data-id="element-144" />
    <MortarPestle className="absolute bottom-32 right-[6%] w-8 h-8 opacity-20 animate-float-soft" color="#A88838" style={{
    ['--rot' as any]: '20deg',
    transform: 'rotate(20deg)',
    animationDelay: '0.5s'
  }} data-id="element-145" />
  </div>;